var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page full error"},[_c('b-jumbotron',{attrs:{"header":"401","lead":"Unauthorized"}},[_c('p',[_vm._v("認証エラー")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }